import { Injectable } from '@angular/core';
import { Keys, StorageService } from './service/storage.service';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from "rxjs";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private storageService: StorageService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // This condition add only for retailer partner(like: quid)
        if (
            Boolean(this.storageService.getItem(Keys.COMING_FROM_RETAILER_PARTNER_PAYMENT_LINK)) &&
            !Boolean(this.storageService.getItem(Keys.RETAILER_PARTNER_LINK_VALIDATED))
        ) {
            this.storageService.clear();
            this.router.navigate(['/borrow']);
            return false;
        }

        if (this.storageService.getItem(Keys.PROFILE_ID)) {
            // logged in so return true
            return true;
        }

        this.router.navigate(['/login'], { queryParams: { 'redirectUrl': state.url } });
        return false;
    }
}

@Injectable()
export class BorrowGuard implements CanActivate {
    constructor(private router: Router, private storageService: StorageService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (!this.storageService.getItem(Keys.SUBMIT_LOAN)) {
            return true;
        }

        this.router.navigate(['/loansanction']);
        return false;
    }
}

@Injectable()
export class LenderGuard implements CanActivate {

    constructor(private router: Router, private storageService: StorageService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.storageService.getItem(Keys.INVEST_SUBMIT)) {
            return true;
        }

        this.router.navigate(['/lenderinitial']);
        return false;
    }
}

@Injectable()
export class LenderObstructGuard implements CanActivate {

    constructor(private router: Router, private storageService: StorageService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        /* Allow a user to access borrower specific pages only if the user is either not a lender or if user is both
         a borrower and a lender. */
        return !this.storageService.getItem(Keys.LENDER) || (this.storageService.getItem(Keys.BORROWER) === 'true');
    }
}

@Injectable()
export class BorrowerObstructGuard implements CanActivate {

    constructor(private router: Router, private storageService: StorageService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.storageService.getItem(Keys.LENDER) === 'true') {
            return true;
        } else {
            this.router.navigate(['invest']);
            return false;
        }
    }
}

@Injectable()
export class NewUserObstructGuard implements CanActivate {

    constructor(private router: Router, private storageService: StorageService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.storageService.getItem(Keys.LENDER) === 'true') {
            this.router.navigate(['investordashboard']);
            return false;
        } else if (this.storageService.getItem(Keys.BORROWER) === 'true') {
            this.router.navigate(['borrowerdashboard']);
            return false;
        } else {
            return true;
        }
    }
}
